
namespace GeniuzPOS.Purchase {
    import fld = ListAppCreditNoteRow.Fields


    @Serenity.Decorators.registerClass()
    export class ListAppCreditNoteGrid extends Serenity.EntityGrid<ListAppCreditNoteRow, any> {
        protected getColumnsKey() { return ListAppCreditNoteColumns.columnsKey; }
        protected getDialogType() { return ListAppCreditNoteDialog; }
        protected getIdProperty() { return ListAppCreditNoteRow.idProperty; }
        protected getInsertPermission() { return ListAppCreditNoteRow.insertPermission; }
        protected getLocalTextPrefix() { return ListAppCreditNoteRow.localTextPrefix; }
        protected getService() { return ListAppCreditNoteService.baseUrl; }

        constructor(container: JQuery) {
            super(container);
        }
        protected getButtons(): Serenity.ToolButton[] {
            var buttons = super.getButtons();
            // let self = this;
            // self.toolbar.findButton('add-button').text('สร้างรายการ');
            buttons.splice(Q.indexOf(buttons, x => x.cssClass == "add-button"), 1);

            return buttons;
        }

        protected getQuickFilters(): Serenity.QuickFilter<Serenity.Widget<any>, any>[] {

            let filters = super.getQuickFilters();


             

            var userId = Q.first(Administration.UserRow.getLookup().items, x => x.Username == Authorization.userDefinition.Username);
             var userapprole = Q.tryFirst(Administration.UserApprovalRoleRow.getLookup().items, x => x.UserId == userId.UserId);


            Q.first(filters, x => x.field == fld.WaitApprove).init = w => {

                (w as Serenity.StringEditor).value = userapprole.ApprGroupCode ?? "";
               
            };
         

            return filters;
        }
    }
}